"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BugCatchComponent = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
class BugCatchComponent extends gotti_1.Component {
    constructor() {
        super(Constants_1.SYSTEMS.BUG_CATCH);
    }
}
exports.BugCatchComponent = BugCatchComponent;
//# sourceMappingURL=module.js.map